// Styles
import styles from './index.module.sass';
import { useTranslation } from 'react-i18next';

export default function LastFooter({ screenSize, history }) {
  const { t } = useTranslation('footer');
  const location = process.env.REACT_APP_COUNTRY;

  function privacy() {
    if (location === 'MX') {
      history.push('/cart/consultancy/legal/aviso_de_privacidad_mx');
      // window.open('https://www.terramarbrands.com.mx/privacy/');
    } else {
      history.push('/cart/consultancy/legal/privacy_policy_us');
      // window.open('https://www.terramarbrands.com.mx/privacy/');
    }
  }

  function terms() {
    if (location === 'MX') {
      window.open('https://www.terramarbrands.com.mx/terms/');
    } else {
      window.open('https://www.terramarbrands.com.mx/terms/');
    }
  }

  return (
    <div className={`${styles.lastFooter} ${styles[screenSize]}`}>
      {(screenSize !== 'phone' && (
        <>
          <div className={styles.left}>
            <div className={styles.brandName}>© 2022 Terramar Brands</div>
            <div>{t('label1')}</div>
          </div>
          <div className={styles.right}>
            <span>{t('label2')}</span>
            <a
              href='https://www.facebook.com/terramarbrandsUSA/?locale=es_LA'
              target='_blank'
              rel='noopener noreferrer'>
              <img
                src={`https://webimages.terramarbrands.com.mx/webpage/icono-facebook-dorado.svg`}
                alt=''
                className={styles.image}
              />
            </a>
            <a
              href='https://www.youtube.com/channel/UCUD9n6CPGwtZBKIAaYMlB_A/featured'
              target='_blank'
              rel='noopener noreferrer'>
              <img
                src={`https://webimages.terramarbrands.com.mx/webpage/icono-youtube-dorado.svg`}
                alt=''
                className={styles.image}
              />
            </a>
            <a
              href='https://www.instagram.com/terramarbrandsusa/'
              target='_blank'
              rel='noopener noreferrer'>
              <img
                src={`https://webimages.terramarbrands.com.mx/webpage/instagram.svg`}
                alt=''
                className={styles.image}
              />
            </a>
            <a href='https://twitter.com/TerramarUsa' target='_blank' rel='noopener noreferrer'>
              <img
                src={`https://webimages.terramarbrands.com.mx/webpage/twitter.svg`}
                alt=''
                className={styles.image}
              />
            </a>
          </div>
        </>
      )) || (
        <>
          <div className={styles.left}>
            <span className={styles.span}>{t('label2')}</span>
            <div className={styles.flex}>
              <a
                href='https://www.facebook.com/terramarbrandsUSA/?locale=es_LA'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={`https://webimages.terramarbrands.com.mx/webpage/icono-facebook-dorado.svg`}
                  alt=''
                  className={styles.image}
                />
              </a>
              <a
                href='https://www.youtube.com/channel/UCUD9n6CPGwtZBKIAaYMlB_A/featured'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={`https://webimages.terramarbrands.com.mx/webpage/icono-youtube-dorado.svg`}
                  alt=''
                  className={styles.image}
                />
              </a>
              <a
                href='https://www.instagram.com/terramarbrandsusa/'
                target='_blank'
                rel='noopener noreferrer'>
                <img
                  src={`https://webimages.terramarbrands.com.mx/webpage/instagram.svg`}
                  alt=''
                  className={styles.image}
                />
              </a>
              <a href='https://twitter.com/TerramarUsa' target='_blank' rel='noopener noreferrer'>
                <img
                  src={`https://webimages.terramarbrands.com.mx/webpage/twitter.svg`}
                  alt=''
                  className={styles.image}
                />
              </a>
            </div>
          </div>
          <div className={styles.left}>
            <div className={styles.brandNameMobile}>
              {t('labelSite')} {t('labelSite2')}
            </div>
          </div>
          <div className={styles.left}>
            <div className={styles.brandName}>© 2022 Terramar Brands</div>
            <div>{t('label1')}</div>
          </div>
          <div className={styles.left}>
            <div className={styles.terms}>
              <div className={styles.link} onClick={() => privacy()}>
                {t('privacy')}
              </div>
              <div>&nbsp;</div>
              {location === 'MX' && (
                <div className={styles.link} onClick={() => terms()}>
                  {t('terms')}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
